import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { modalZIndex } from '@ugc-utils/modal-z-index';
import { FontType } from '@ugc-utils/utils';
import { ReportAbuseType } from '@ugc-containers/ugc-report-abuse/interfaces';

@Component({
  tag: 'ugc-review-operate-modal',
  shadow: false,
})
export class UgcReviewOperateModal {
  render() {
    const {
      isShowSwitchLanguageModal,
      reviewStaticLanguage: { IDS_UGC_MORE_OPTIONS = '' } = {},
      switchLanguageModal: { isModal, reviewItem },
    } = state;
    const { id: reviewId, shareUrl, translatedTo, languageCode, translatedToLanguageName, languageName } = reviewItem;
    return (
      <ugc-drawer
        isShow={isShowSwitchLanguageModal}
        modalTitle={IDS_UGC_MORE_OPTIONS}
        zIndex={modalZIndex['ugc-report-operate-modal']}
        handleCancel={() => (state.isShowSwitchLanguageModal = false)}
        isShowButton={false}
      >
        {isShowSwitchLanguageModal && (
          <div class="pb-24 px-12 mx-8 rounded-4">
            <div class="py-4 border-bottom-solid border-1 border-gray-300">
              <ugc-share
                type="button"
                shareWidgetLayer={modalZIndex['share-widget-layer']}
                sid={`${isModal}-${reviewId}`}
                shareUrl={shareUrl}
                position="bottom"
                gaEvent={{
                  'data-ga-event-name': 'open_share_widget',
                  'data-ga-content-type': 'review',
                  'data-ga-location-detail': 'pdp review',
                }}
                fontType={FontType.small}
                data-testid="pdp-review-share"
              />
            </div>
            {translatedTo && (
              <div class="py-4 border-bottom-solid border-1 border-gray-300">
                <ugc-review-switch-language
                  reviewId={reviewId}
                  translatedTo={translatedTo}
                  translatedToLanguageName={translatedToLanguageName}
                  languageCode={languageCode}
                  languageName={languageName}
                />
              </div>
            )}
            <div class="py-4">
              <ugc-report-abuse
                type={ReportAbuseType.Review}
                variant="button"
                referenceId={reviewId}
                fontType={FontType.small}
                data-testid="pdp-review-report-abuse"
              />
            </div>
          </div>
        )}
      </ugc-drawer>
    );
  }
}
